module.exports = __webpack_public_path__ + "media/images/badges/yogasix/inactive/Y6Warrior2022_Badges_2500_Inactive@1x-e9168215ac4c69bb2de1251fa148a63e.png";